import { getResources } from "../../framework/client/resource";
import { ApplicationResource } from "../../../common/application/enumeration/ApplicationResource";
import { VatRate } from "../../../common/application/model/VatRate";

export async function isOverlappingVatRate(vatRate: Omit<VatRate, 'id'> & { id?: string }) {
    const parameters = new Map()
        .set('countryCode', vatRate.countryCode)
        .set('startDate', vatRate.startDate)
        .set('vatCode', vatRate.vatCode);

    const query = [
        `countryCode = {countryCode}`,
        `vatCode = {vatCode}`,
        `(endDate >= {startDate} OR endDate IS NULL)`,
    ];

    if (vatRate.endDate) {
        parameters.set('endDate', vatRate.endDate);
        query.push(`startDate <= {endDate}`);
    }

    if (vatRate.id) {
        parameters.set('id', vatRate.id);
        query.push( `id <> {id}`);
    }

    parameters.set('query', query.join(' AND '));
    const vatRates = await getResources<VatRate>(ApplicationResource.VAT_RATE, -1, parameters);

    return vatRates.length === 0;
}
